import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  PinPointInput,
  FormRow,
  SaveCancel
} from '../../../components'
import Select from 'react-select'

const Form = () => {
  return (
    <div>
      <h1 className="mt-8 xl:mt-0 text-lg mb-5 font-bold font-primary xl:hidden">
        Add New Location / Edit Location
      </h1>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Province</Label>
          <Select className="text-sm" options={[]} placeholder="Choose Province" />
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <Label>City</Label>
          <Select className="text-sm" options={[]} placeholder="Choose City" />
        </div>
      </div>
      <FormRow>
        <Label>Address (Optional)</Label>
        <Input className="w-full" defaultValue="Jl. Cijagra No.48, Cijagra, Lengkong, Kota Bandung 40265"/>
      </FormRow>
      <FormRow last>
        <Label>Pin Point (Optional)</Label>
        <PinPointInput />
      </FormRow>
      <SaveCancel />
    </div>
  )
}

export { Form }
